module.exports = __webpack_public_path__ + "img/3-3.925ca95e.svg";